import { render, staticRenderFns } from "./Inicio.vue?vue&type=template&id=d12a391e&scoped=true"
import script from "./Inicio.vue?vue&type=script&lang=js"
export * from "./Inicio.vue?vue&type=script&lang=js"
import style0 from "./Inicio.vue?vue&type=style&index=0&id=d12a391e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d12a391e",
  null
  
)

export default component.exports